import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as fareRuleActions from './../../../../actions/fareRuleAction';
import FareRules from './FareRules';

const mapStateToProps = state => {
    return {
        fareRuleState: state.fareRuleReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListFareRules: (filters) => dispatch(fareRuleActions.getListFareRules(filters)),
        deleteFareRuleDetail: (fareRule, filters) => dispatch(fareRuleActions.deleteFareRuleDetail(fareRule, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FareRules));
